import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const awardSchema = itemSchema.extend({
  title: z.string().min(1),
  awarder: z.string(),
  date: z.string(),
  summary: transformerMdContentParam,
  url: urlSchema,
});

export const minimalAwardSchema = awardSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Award = z.infer<typeof awardSchema>;
export type MinimalAward = z.infer<typeof minimalAwardSchema>;

// Defaults
export const defaultAward: Award = {
  ...defaultItem,
  title: "",
  awarder: "",
  date: "",
  summary: "",
  url: defaultUrl,
};

export const deminimalizeAward = (award: MinimalAward): Award => {
  return {
    ...defaultAward,
    ...award,
    id: createId(),
  };
};
